module.exports = __webpack_public_path__ + "static/Portrait-MediumItalic-c84994b1b2e83139ecf29099e6f47919.woff";